import { useState } from "react";
import { Button, ModalDelete } from "expano-components";
import useDelete from "hooks/useDelete";

import EditKeywordModal from "./EditKeywordModal";

const Item = ({ id, name, volumen, is_title, is_used, refetch }) => {
  const [is_open_delete_modal, handleOpenDeleteModal] = useState(false);
  const [is_open_edit_modal, handleOpenEditModal] = useState(false);

  const { _delete } = useDelete({
    path: `/product_group_country_keywords/${id}`,
    onSuccess: () => [handleOpenDeleteModal(false), refetch()],
  });

  return (
    <>
      {is_open_delete_modal && (
        <ModalDelete
          name={`słowo kluczowe ${name}?`}
          handleClose={() => handleOpenDeleteModal(false)}
          handleDelete={_delete}
        />
      )}
      {is_open_edit_modal && (
        <EditKeywordModal
          id={id}
          initialValues={{
            name,
            volumen,
            is_title,
            is_used,
          }}
          refetch={refetch}
          handleClose={() => handleOpenEditModal(false)}
        />
      )}
      <tr
        style={
          is_title
            ? { backgroundColor: "rgba(10, 190, 140,0.1)" }
            : is_used
            ? { backgroundColor: "rgba(242, 174, 73, 0.2)" }
            : {}
        }
      >
        <td className="box-name">{name}</td>
        <td className="box-name">{volumen ? parseInt(volumen) : "-"}</td>
        <td className="box-delete">
          <Button type="edit" onClick={() => handleOpenEditModal(true)} />
          <Button
            type="delete-bin"
            onClick={() => handleOpenDeleteModal(true)}
          />
        </td>
      </tr>
    </>
  );
};

export default Item;
